(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/rules/assets/javascripts/rules/rules.js') >= 0) return;  svs.modules.push('/components/numbergames/rules/assets/javascripts/rules/rules.js');

'use strict';

const _excluded = ["productId"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
let productMapping;
let rules;
let isSelfService;





const rulesFunctions = {
  EUROJACKPOT: () => isSelfService() ? rules.EUROJACKPOT_SELFSERVICE : rules.EUROJACKPOT,
  VIKINGLOTTO: () => isSelfService() ? rules.VIKINGLOTTO_SELFSERVICE : rules.VIKINGLOTTO,
  LOTTO: () => isSelfService() ? rules.LOTTO_SELFSERVICE : rules.LOTTO,
  KENO: () => isSelfService() ? rules.KENO_SELFSERVICE : rules.KENO
};

function getRules(product) {
  var _rulesFunctions$produ;
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (typeof product === 'object') {
    var _product = product;
    ({
      productId: product
    } = _product);
    options = _objectWithoutProperties(_product, _excluded);
    _product;
  }
  return (_rulesFunctions$produ = rulesFunctions[productMapping.getProductId(product)]) === null || _rulesFunctions$produ === void 0 ? void 0 : _rulesFunctions$produ.call(rulesFunctions, options);
}
if (svs.isServer) {
  const path = require('path');
  rules = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, require(path.join(__dirname, 'eurojackpot.es6'))), require(path.join(__dirname, 'keno.es6'))), require(path.join(__dirname, 'lotto.es6'))), require(path.join(__dirname, 'vikinglotto.es6'))), require(path.join(__dirname, 'joker.es6')));
  const trinidadCore = require('@svenskaspelab/trinidad-core').core;
  ({
    productMapping
  } = trinidadCore.components.require('numbergames', 'product-mapping'));
  isSelfService = () => trinidadCore.config.options.isSelfService;
  module.exports = {
    rules,
    getRules
  };
} else {
  isSelfService = () => svs.core.config.data.svsconfig.isSelfService;
  ({
    rules,
    productMapping
  } = svs.numbergames);
  rules.getRules = getRules;
}

 })(window);